import { FC, ReactNode } from 'react';
import { mergeClasses } from 'shared/utils/mergeClasses';

interface ErrorMessageProps {
  children: ReactNode;
  id?: string;
  className?: string;
}

export const ErrorMessage: FC<ErrorMessageProps> = ({ children, className = '', id }) => {
  return (
    <p id={id} className={mergeClasses('mt-1 text-sm text-red', className)}>
      {children}
    </p>
  );
};
